import { registerLocaleData } from '@angular/common';
import localeZh from '@angular/common/locales/zh';
import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { I18NEXT_SERVICE, I18NextModule, I18NextTitle, ITranslationService, defaultInterpolationFormat } from 'angular-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { ClientTranslationService } from '../../core/internationalization/client-translation-service';

registerLocaleData(localeZh);

const i18nextOptions = {
  whitelist: ['en', 'zh'],
  fallbackLng: 'en',
  debug: false,
  returnEmptyString: false,
  partialBundledLanguages: true,
  ns: [
    'translation',
    'validation',
    'error',
    'module.rbi',
    'module.hierarchy',
    'module.integration',
    'module.admin',
    'module.hb-shared',
    'module.model',
    'module.hb-shared-ui',
    'module.eventTemplates',
    'module.idms',
    'module.thickness-management',
    'module.licensing',
    'module.functions',
    'module.nodeAttribute',
    'module.lookups',
    'module.component-library',
    'module.events',
    'module.mitigation',
    'module.reports',
    'languages',
    'module.dashboard',
    'module.about',
    'module.thickness-management',
    'module.security',
    'module.node',
  ],
  backend: {
    loadPath: 'assets/locales/default/en.translation.json',
  },

  interpolation: {
    format: I18NextModule.interpolationFormat(defaultInterpolationFormat),
    escapeValue: false,
  },
  // lang detection plugin options
  detection: {
    // order and from where user language should be detected
    order: ['cookie'],
    // keys or params to lookup language from
    lookupCookie: 'lang',
    // cache user language on
    caches: ['cookie'],
  },
};

export const appInit = (i18next: ITranslationService, clientTranslationService: ClientTranslationService) => async () => {
  const clientNamespace = await clientTranslationService.getClientNamespace();
  const lngOption = { ...i18nextOptions };

  lngOption.backend = {
    loadPath: `assets/locales/${clientNamespace}/{{lng}}.{{ns}}.json`,
  };

  return i18next.use(HttpApi).use(LanguageDetector).init(lngOption);
};

export const localeIdFactory = (i18next: ITranslationService) => i18next.language;

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE, ClientTranslationService],
    multi: true,
  },
  {
    provide: Title,
    useClass: I18NextTitle,
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory,
  },
];

export const i18NextModule = I18NextModule.forRoot();
